export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'VFAIRUSER_TEMPLATE',
        data => ({
            id: data.vfairId,
            vfairId: data.vfairId,
            userId: data.userId,
            interested: data.interested,
        }),
    ],
    '/user': {
        '/me': {
            authorize: true,
            template: [
                'VFAIRUSER_TEMPLATE',
                data => ({
                    id: data.vfairId,
                    vfairId: data.vfairId,
                    userId: data.userId,
                    interested: data.interested,
                    invited: data.invited,
                }),
            ],
            GET: {},
            '/:vfair_id': {
                authorize: true,
                template: [
                    'VFAIRUSER_TEMPLATE',
                    data => ({
                        id: data.vfairId,
                        vfairId: data.vfairId,
                        userId: data.userId,
                        interested: data.interested,
                        invited: data.invited,
                    }),
                ],
                GET: {},
                POST: {},
                PUT: {},
            },
        },
    },
};
